import { ACTIVE_BANNERS, CHARACTERS, CAMPAIGN_NODES, PLAYER } from '../data';
import { ASSETS } from '../assetManifest.js';
import iconMap from '../iconMap.js';
import { homeButtonsConfig } from '../appConfig';

export const onClickButton = (id, app) => {
  const allButtons = [...homeButtonsConfig.leftButtons, ...homeButtonsConfig.rightButtons];
  const button = allButtons.find(b => b.id === id);
  if (button?.action && app[button.action]) {
    app[button.action]();
  }
};

export const getHomeData = (app) => {
  const featuredBanner = ACTIVE_BANNERS.find(banner => banner.type === 'featured');
  const featuredCharacter = featuredBanner ? CHARACTERS[featuredBanner.highlight.characterId] : null;
  const currentNode = CAMPAIGN_NODES.find(node => node.id === PLAYER.currentCampaignNode);
  const unreadCount = PLAYER.chats?.unreadChatIds?.length;
  
  return {
    images: {
      background: ASSETS.backgrounds.boxArt?.path
    },
    leftButtons: homeButtonsConfig.leftButtons.map(button => ({
      ...button,
      icon: iconMap[button.id],
      notification: button.id === 'messages' ? (unreadCount > 0 ? unreadCount : null) :
                   button.id === 'territory' ? 1 : null
    })),
    rightButtons: homeButtonsConfig.rightButtons.map(button => ({
      ...button,
      icon: iconMap[button.id],
      notification: button.id === 'messages' ? (unreadCount > 0 ? unreadCount : null) :
        button.id === 'territory' ? 1 : null
    })),
    featuredBanner: featuredCharacter ? {
      name: featuredCharacter.name.split(' ')[0],
      subtitle: featuredCharacter.type,
      image: ASSETS.characters[featuredCharacter.prototypeId].path,
      stars: featuredCharacter.rarity,
      type: featuredBanner.type,
      timeRemaining: featuredBanner.timeRemaining,
      objectPosition: "60% top"
    } : null,
    currentCampaign: {
      levelNumber: CAMPAIGN_NODES.findIndex((c) => currentNode.id === c.id) + 1,
      name: currentNode.name,
      node: currentNode,
      image: ASSETS.locations[currentNode.backgroundId]
    }
  };
};
